import { useStaticQuery, graphql } from 'gatsby';

export interface Item {
  title: string;
  text: string;
}

export const useConsultationRoomImages = () => {
  const { image6, image5, image1, image2, image3 } = useStaticQuery(graphql`
    query ConsultationRoomImages {
      image6: file(relativePath: { eq: "about/rooms/consultation-room/consultation-room-06.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image5: file(relativePath: { eq: "about/rooms/consultation-room/consultation-room-05.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image1: file(relativePath: { eq: "about/rooms/consultation-room/consultation-room-01.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image2: file(relativePath: { eq: "about/rooms/consultation-room/consultation-room-02.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image3: file(relativePath: { eq: "about/rooms/consultation-room/consultation-room-03.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return [
    { alt: 'ClinicalRooms', src: image6.childImageSharp.fluid },
    { alt: 'Intraoral 3D Scanner', src: image5.childImageSharp.fluid },
    { alt: 'Intra-oral cameras', src: image1.childImageSharp.fluid },
    { alt: 'Digital periapical x-ray technology', src: image2.childImageSharp.fluid },
    { alt: 'Magnifying Surgical Loupes', src: image3.childImageSharp.fluid },

  ];
};
